import apiPrd from 'services/apiPrd'

export const PendingTypeService = {
  async getAllPendings(payload) {
    const res = await apiPrd.post('/pending/search', payload)
    const { status, data } = res
    return { status, data }
  },
  async disablePendency({ id, observation }) {
    const observationParam = observation ? `observation=${encodeURIComponent(observation)}` : ''
    const url = `/pending/${id}/dispose${observationParam ? `?${observationParam}` : ''}`

    const res = await apiPrd.post(url)
    const { status, data } = res
    return { status, data }
  },

  async resolvePendency({ id, observation }) {
    const observationParam = observation ? `observation=${encodeURIComponent(observation)}` : ''
    const url = `/pending/${id}/resolve${observationParam ? `?${observationParam}` : ''}`

    const res = await apiPrd.post(url)
    const { status, data } = res
    return { status, data }
  },
  async findPendencyById(id, targetType) {
    const res = await apiPrd.get(`/pending/${id}?targetType=${targetType}`)
    const { status, data } = res
    return { status, data }
  },
  async markAsUnviewed(id) {
    const res = await apiPrd.get(`/pending/${id}/markAsUnviewed`)
    const { status, data } = res
    return { status, data }
  },
  async getAllPendingTypes() {
    const res = await apiPrd.get('/pendingType')
    const { status, data } = res
    return { status, data }
  },
  async fetchPendingIndicators() {
    const res = await apiPrd.get('/pending/indicators')
    const { status, data } = res
    return { status, data }
  },
  async generateReport(payload) {
    const res = await apiPrd.post('/pending/report', payload)
    const { status, data } = res
    return { status, data }
  },
}
